import { baseModalLayoutDriverFactory } from '../BaseModalLayout/BaseModalLayout.uni.driver';
import { textButtonDriverFactory } from '../TextButton/TextButton.uni.driver';
import { dataHooks } from './constants';
import { findByHook } from '../test-utils/utils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';

export const announcementModalLayoutDriverFactory = (base: UniDriver) => {
  const getLink = () =>
    textButtonDriverFactory(findByHook(base, dataHooks.link));

  return {
    ...baseModalLayoutDriverFactory(base),

    /** Returns if the link component text content */
    getLinkText: () => getLink().getButtonTextContent(),

    /** Clicks the link component */
    clickLink: async () => getLink().click(),
  };
};

export type AnnouncementModalLayoutUniDriver = ReturnType<
  typeof announcementModalLayoutDriverFactory
>;
